import { PageWrapper } from '../components/layout/PageWrapper';
import { Seo } from '../components/Seo';

export function PrivacyPage() {
  return (
    <PageWrapper className="max-w-3xl">
      <Seo title="Политика конфиденциальности" path="/privacy" noindex />
      <h1 className="text-4xl font-bold text-white mb-2">Политика конфиденциальности</h1>
      <p className="text-gray-500 text-sm mb-10">Последнее обновление: 27 мая 2026 г.</p>

      <div className="space-y-8 text-gray-300 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">1. Кто мы</h2>
          <p>
            Клуб Мафии Квинсленда (далее — «Клуб», «мы») — некоммерческий игровой клуб,
            расположенный в Брисбене, Австралия. Сайт доступен по адресу{' '}
            <span className="text-mafia-accent">mafiaclub.com.au</span>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">2. Какие данные мы собираем</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>
              <span className="text-white font-medium">Данные аккаунта:</span> имя и адрес
              электронной почты, полученные от Google или Apple при входе через OAuth.
            </li>
            <li>
              <span className="text-white font-medium">Данные бронирования:</span> дата игры,
              имя игрока, email — для подтверждения участия.
            </li>
            <li>
              <span className="text-white font-medium">Платёжные данные:</span> мы не храним
              данные банковских карт. Оплата обрабатывается сервисом Stripe. Мы получаем только
              подтверждение оплаты и сумму транзакции.
            </li>
            <li>
              <span className="text-white font-medium">Технические данные:</span> стандартные
              данные веб-сервера (IP-адрес, тип браузера) через AWS CloudFront.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">3. Как мы используем данные</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Подтверждение и управление бронированием мест на игры</li>
            <li>Отображение турнирных таблиц и рейтингов</li>
            <li>Отправка квитанций об оплате (через Stripe)</li>
            <li>Связь с участниками по вопросам, касающимся игр</li>
          </ul>
          <p className="mt-3">
            Мы не продаём и не передаём ваши данные третьим лицам в маркетинговых целях.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">4. Третьи стороны</h2>
          <div className="space-y-3">
            <div className="bg-mafia-card rounded-xl p-4 border border-gray-800">
              <p className="text-white font-medium">Google LLC</p>
              <p className="text-sm text-gray-400">
                Авторизация через Google OAuth 2.0. Политика конфиденциальности:{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-mafia-accent hover:underline">
                  policies.google.com/privacy
                </a>
              </p>
            </div>
            <div className="bg-mafia-card rounded-xl p-4 border border-gray-800">
              <p className="text-white font-medium">Apple Inc.</p>
              <p className="text-sm text-gray-400">
                Авторизация через Sign in with Apple. Политика конфиденциальности:{' '}
                <a href="https://www.apple.com/legal/privacy" target="_blank" rel="noopener noreferrer" className="text-mafia-accent hover:underline">
                  apple.com/legal/privacy
                </a>
              </p>
            </div>
            <div className="bg-mafia-card rounded-xl p-4 border border-gray-800">
              <p className="text-white font-medium">Stripe, Inc.</p>
              <p className="text-sm text-gray-400">
                Обработка платежей. Политика конфиденциальности:{' '}
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className="text-mafia-accent hover:underline">
                  stripe.com/privacy
                </a>
              </p>
            </div>
            <div className="bg-mafia-card rounded-xl p-4 border border-gray-800">
              <p className="text-white font-medium">Amazon Web Services (AWS)</p>
              <p className="text-sm text-gray-400">
                Хостинг сайта и базы данных (регион ap-southeast-2, Сидней). Политика:{' '}
                <a href="https://aws.amazon.com/privacy" target="_blank" rel="noopener noreferrer" className="text-mafia-accent hover:underline">
                  aws.amazon.com/privacy
                </a>
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">5. Хранение и защита данных</h2>
          <p>
            Данные хранятся в базе данных AWS DynamoDB в регионе ap-southeast-2 (Сидней,
            Австралия). Доступ к данным защищён шифрованием в покое (AES-256) и при передаче
            (TLS 1.2+). Мы не храним данные дольше, чем необходимо для работы Клуба.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">6. Ваши права</h2>
          <p>
            В соответствии с австралийским Законом о конфиденциальности (Privacy Act 1988) вы
            имеете право запросить доступ к своим данным, их исправление или удаление. Для этого
            свяжитесь с нами по электронной почте, указанной ниже.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">7. Контакты</h2>
          <p>
            По вопросам, связанным с конфиденциальностью, пишите на:{' '}
            <a href="mailto:privacy@mafiaclub.com.au" className="text-mafia-accent hover:underline">
              privacy@mafiaclub.com.au
            </a>
          </p>
        </section>
      </div>
    </PageWrapper>
  );
}
